import { boolean as yupBoolean, mixed, number, object, string } from 'yup';

import { SourcesProvider, SourcesAuthType } from '@api/types.gen';

import { intervalValidation } from '../../../components/IntervalField';
import { AuthMode } from '../../../components/GitAuthentication';

export interface SettingsFormValues {
  name: string;
  url: string;
  tlsSkipVerify: boolean;
  authEnabled: boolean;
  authMode: AuthMode;
  provider: SourcesProvider;
  type: SourcesAuthType;
  username: string;
  password: string;
  sharedCredentialId?: number;
  pollingEnabled: boolean;
  interval: string;
}

export const validationSchema = object({
  name: string().required('Name is required'),
  url: string().required('Repository URL is required'),
  tlsSkipVerify: yupBoolean().defined(),
  authEnabled: yupBoolean().defined(),
  authMode: mixed<AuthMode>().oneOf(['manual', 'shared']).defined(),
  provider: mixed<SourcesProvider>()
    .oneOf(Object.values(SourcesProvider))
    .defined(),
  type: mixed<SourcesAuthType>()
    .oneOf(Object.values(SourcesAuthType))
    .defined(),
  username: string().when(['authEnabled', 'authMode'], {
    is: (authEnabled: boolean, authMode: AuthMode) =>
      authEnabled && authMode !== 'shared',
    then: (schema) => schema.required('Username is required'),
    otherwise: (schema) => schema.optional(),
  }),
  password: string().optional(),
  sharedCredentialId: number().when(['authEnabled', 'authMode'], {
    is: (authEnabled: boolean, authMode: AuthMode) =>
      authEnabled && authMode === 'shared',
    then: (schema) => schema.required('A shared credential must be selected'),
    otherwise: (schema) => schema.optional(),
  }),
  pollingEnabled: yupBoolean().defined(),
  interval: string()
    .default('')
    .when('pollingEnabled', {
      is: true,
      then: () => intervalValidation(),
    }),
});
